import {
  SET_TOTAL_ASSIGNMENTS,
  SET_TOTAL_APPLICATIONS,
  APPLY_ASSIGNMENT,
  CANCEL_APPLY_ASSIGNMENT,
  CLOSE_SUCCESS_SEND_APPLICATION,
  GET_ALL_ASSIGNMENTS_SUCCESS,
  GET_ASSIGNMENT_OFFERED_TO_EMAIL_SUCCESS,
  LOCATION_CHANGE,
  SEARCH_ASSIGNMENT,
  SEARCH_ASSIGNMENT_FAILED,
  SEARCH_ASSIGNMENT_SUCCESS,
  SEE_MY_APPLICATION,
  SEND_APPLICATION_SUCCESS,
  TRACK_APPLICATION_SUCCESS
} from '../constants'

const initialState = {
  assignmentRows: [],
  myAssignmentRows: [],
  showApplyForm: false,
  assignmentPageSize: 10,
  applySuccess: false,
  appliedData: [],
  appliedAssignmentId: [],
  shouldCloseExpand: false,
  isSearchAssignmentSuccess: false,
  isSeeMyApplication: false,
  appliedData_search: [],
  searchAssignmentStatus: 0,
  directlyOfferedContractData: [],
  directlyOfferedAssignmentId: [],
  totalNewAssignments: []
}

const assignmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_TOTAL_ASSIGNMENTS:
      return Object.assign(
        {},
        { ...state },
        {
          totalNewAssignments: action.data
        }
      )
    case SET_TOTAL_APPLICATIONS:
      return Object.assign(
        {},
        { ...state },
        {
          totalNewApplications: action.data
        }
      )

    case GET_ALL_ASSIGNMENTS_SUCCESS:
      // Remove the assignments that have been applied
      // Because this action return the assignments without telling that which one have been applied
      // const newAssignmentsRows = filterItemsByIds(
      //   action.data,
      //   state.appliedAssignmentId,
      //   false
      // )
      // const rearrange_assignmentRows = rearrangeAssignments(newAssignmentsRows)

      return Object.assign(
        {},
        { ...state },
        {
          assignmentRows: action.data,
          // applySuccess: false
          isSeeMyApplication: false
        }
      )
    case TRACK_APPLICATION_SUCCESS:
      // This method return the assignments that have been applied with the status of applications
      const assignment_id_collection = []
      const data = action.data
      data.forEach((item) => {
        assignment_id_collection.push(item.assignment_id)
      })
      const uniqueAssignmentId = [...new Set(assignment_id_collection)]

      return Object.assign(
        {},
        { ...state },
        {
          appliedData: action.data,
          appliedAssignmentId: uniqueAssignmentId
        }
      )

    case SEARCH_ASSIGNMENT_SUCCESS:
      const newAssignmentRows = action.data
      // Remove assignments that have been applied
      // const removeApplied = filterItemsByIds(
      //   newAssignmentRows,
      //   state.appliedAssignmentId,
      //   false
      // )
      // const rearrange_assignment_Rows = rearrangeAssignments(removeApplied)
      // Collect assignments that have been applied
      const collectApplied = filterItemsByIds(
        newAssignmentRows,
        state.appliedAssignmentId,
        true
      )
      const pageSize = action.pageSize
      const search_form_blank =
        action.formValues ===
        '{"employerdetails":[{"jobtitle":"","industrytype":null,"companyname":"","city":"","PinnedAssignment":false}]}'
      return Object.assign(
        {},
        { ...state },
        {
          assignmentRows: newAssignmentRows,
          appliedData_search: search_form_blank
            ? state.appliedData
            : collectApplied,
          assignmentPageSize: pageSize,
          isSearchAssignmentSuccess: true,
          searchAssignmentStatus: action.formValues.employerdetails[0].status
        }
      )
    case SEARCH_ASSIGNMENT:
    case SEARCH_ASSIGNMENT_FAILED:
      return Object.assign(
        {},
        { ...state },
        {
          isSearchAssignmentSuccess: false,
          searchAssignmentStatus: 0
        }
      )
    case GET_ASSIGNMENT_OFFERED_TO_EMAIL_SUCCESS:
      // There are two types of application:
      // 1. Offered by company at Employment UI
      // 2. Apply at Assignments tab from Kassa UI
      const myAssignmentAgreementRows = [...action.data] // All offered contract
      // Offered contract without application_id is directly offered
      const directlyOfferedContract = myAssignmentAgreementRows.filter(
        (el) => el.application_id === null
      )

      const directlyOfferedAssignmentId = []

      directlyOfferedContract.forEach((item) => {
        directlyOfferedAssignmentId.push(item?.assignment_job_id)
      })

      return Object.assign(
        {},
        { ...state },
        {
          myAssignmentRows: [...action.data],
          directlyOfferedContractData: directlyOfferedContract,
          directlyOfferedAssignmentId: directlyOfferedAssignmentId
        }
      )
    case APPLY_ASSIGNMENT:
      return Object.assign(
        {},
        { ...state },
        {
          showApplyForm: true
        }
      )
    case CANCEL_APPLY_ASSIGNMENT:
      return Object.assign(
        {},
        { ...state },
        {
          showApplyForm: false
        }
      )
    case SEND_APPLICATION_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          applySuccess: true,
          showApplyForm: false
        }
      )
    case CLOSE_SUCCESS_SEND_APPLICATION:
      return Object.assign(
        {},
        { ...state },
        {
          applySuccess: false,
          shouldCloseExpand: true
        }
      )
    case SEE_MY_APPLICATION:
      return Object.assign(
        {},
        { ...state },
        {
          isSeeMyApplication: true
        }
      )
    case LOCATION_CHANGE:
      return Object.assign(
        {},
        { ...state },
        {
          showApplyForm: false,
          applySuccess: false,
          isSearchAssignmentSuccess: false,
          searchAssignmentStatus: 0
        }
      )
    default:
      return state
  }
}

/* This function is used to filter applied assignments.
 * @param {Array} arrayA - The array of items to filter.
 * @param {Array} arrayB - The array of IDs to filter by.
 * @param {boolean} shouldCollect - If true, returns applied assignments; if false, returns non-applied assignments.
 * @returns {Array} - The filtered array.
 */
function filterItemsByIds(arrayA, arrayB, shouldCollect) {
  const idsSet = new Set(arrayB)

  return arrayA.filter((item) =>
    shouldCollect
      ? idsSet.has(item.assignment_id)
      : !idsSet.has(item.assignment_id)
  )
}

export default assignmentReducer
